<div class="container-fluid inbuilt-filters-container mb-2">
    <div class="row">
        <div class="col-12 col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 ">
            <div class="row">
                <div class="{{columnClasses[filter.class] || 'col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3'}} mb-2 p-0 pe-2" *ngFor="let filter of allFilters">
                    <div class="filter-field" *ngIf="filter?.name != 'attributes'">
                        <div class="filter-label-row">
                            <label class="section-name" for="{{filter.label}}">{{filter.label}}</label>
                            <div class="filter-label-icons"
                                *ngIf="filter.selectedCount > 0 && (!isApplyClicked || (isApplyClicked && isAnyFilterValueChanged))">
                                <mat-icon class="filter-icon filter-active-icon"
                                    [title]="filter.selectedCount + ' item(s) selected'">schedule</mat-icon>
                                <mat-icon class="filter-icon filter-reset-icon" title="Clear selection"
                                    (click)="clearSingleFilter(filter)">cancel</mat-icon>
                            </div>
                            <div class="dropdown-loader" *ngIf="filter.isLoading && showView">
                                <mat-spinner class="spinner" diameter="24"></mat-spinner>
                            </div>
                        </div>
                        <!-- <span *ngIf="filter.mandatory" class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span> -->
                        <ng-container [ngSwitch]="filter.type">
                            <ng-container *ngSwitchCase="'singleSelect'">
                                <app-dropdown-with-search [Pixeltracking]="true" [showPlaceholder]="'false'"
                                    searchFlag="true" isMultiSelect="false" [dropdownData]="filter.dropdownData"
                                    [selected]="filter.initialData"
                                    (selectionChange)="setSelectedValues($event,filter.name,filter.type)">
                                </app-dropdown-with-search>
                            </ng-container>
                            <ng-container *ngSwitchCase="'multiselect'">
                                <!-- <app-dropdown-with-search searchFlag="true" [Pixeltracking]="true" [showPlaceholder]="'false'"
                        isMultiSelect="true" [dropdownData]="filter.dropdownData" [selected]="filter.initialData"
                        (selectionChange)="setSelectedValues($event,filter.name)">
                    </app-dropdown-with-search> -->
                                <app-lazy-load-select-dropdown [dropdownData]="filter.dropdownData"
                                    [initialSelectedItems]="filter.default_selection" [searchFlag]="true"
                                    [isMultiselect]="true" [isSelectAll]="filter.isSelectedAll"
                                    [isDataSorted]="filter?.sorted" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name, filter.type)">
                                </app-lazy-load-select-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hierarchal'">
                                <!-- <app-multiselect-group-checkbox 
                        [dropdowndataSource]="filter.dropdownData"
                        [hierarchyDropdownConfig]="hierarchyDropdownConfig" 
                        [selectValues]="filter.initialData"
                        [placeholderText]="'Select '"
                        (selectedHierarchy)="setSelectedValues($event,filter.name)">
                    </app-multiselect-group-checkbox> -->
                                <app-hierarchy-dropdown [initialSelectedItems]="filter.default_selection"
                                    [dropdownData]="filter.dropdownData" [filterKey]="getHierarchyDisplayPath(filter)"
                                    [isSelectedAll]="filter.isSelectedAll" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name,filter.type)"></app-hierarchy-dropdown>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hierarchal-delimiter'">
                                <app-hierarchy-dropdown [initialSelectedItems]="filter.default_selection"
                                    [dropdownData]="filter.dropdownData" [filterKey]="getHierarchyDelimiterFilterKey(filter)"
                                    [isSelectedAll]="filter.isSelectedAll" [resetTrigger]="filter.resetCounter"
                                    (selectedCountChange)="filter.selectedCount = $event"
                                    (selectionChange)="setSelectedValues($event,filter.name,filter.type)"></app-hierarchy-dropdown>
                            </ng-container>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-12 col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 button-block">
            <!-- <div class="col-12 d-flex justify-content-end"> -->
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="resetFilters()" [disabled]="applyLoading">Reset to Default</button>
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="selectAllFilters()" [disabled]="applyLoading">Select All</button>
            <button
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
                (click)="applyFilters()"
                [disabled]="applyLoading || !isAnyFilterSelected || (isApplyClicked && !isAnyFilterValueChanged)">
                <mat-spinner *ngIf="applyLoading" class="search-btn-spinner" diameter="16"></mat-spinner>
                <span *ngIf="!applyLoading">Search</span>
            </button>

            <!-- </div> -->
        </div>

    </div>

</div>